// extracted by mini-css-extract-plugin
export default {"img":"GummyBears_img__YZIuZ"};